// 设备库示例：母线-变压器-线路-馈线元数据与联动计算
import { calculateShortCircuitIEC60909Multi } from './shortCircuit';
import { resolveGroundingImpedance } from './groundingTemplates';

// 示例数据：实际工程请从数据库/配置中维护，并支持版本化
export const FEEDERS = [
  {
    id: 'FDR-1', name: '馈线1',
    bus: { voltage_kV: 10.5 },
    ratedCurrent: 1000,
    ctRatio: 600,
    source: { S_sc_MVA: 500, X_R: 10 },
    transformer: { S_tr_MVA: 20, uk_percent: 6, vector_group: 'Dyn11', secondary_neutral_ground: 'solid' },
    line: { R_per_km_ohm: 0.2, X_per_km_ohm: 0.35, length_km: 0.8, z0_factor: 3 },
    ground: { R_ohm: 0.5, X_ohm: 0 }
  },
  {
    id: 'FDR-2', name: '馈线2',
    bus: { voltage_kV: 10.5 },
    ratedCurrent: 800,
    ctRatio: 800,
    source: { S_sc_MVA: 300, X_R: 8 },
    transformer: { S_tr_MVA: 10, uk_percent: 5, vector_group: 'Yd11', secondary_neutral_ground: 'none' },
    line: { R_per_km_ohm: 0.35, X_per_km_ohm: 0.45, length_km: 1.2, z0_factor: 3 },
    ground: { R_ohm: 1.0, X_ohm: 0 }
  }
];

export function listFeeders() {
  return FEEDERS.map(({ id, label, name }) => ({ id, label: label || name || id }));
}

export function getFeederById(id) {
  return FEEDERS.find((f) => f.id === id);
}

export function computeShortCircuitForFeeder(feeder, opts = {}) {
  if (!feeder) return null;
  const { motors_percent = 0, motors_X_R = 3, c_max = 1.1, c_min = 0.95, temp_operate_c = 80, Un_kV, groundingType } = opts;
  // 根据 UI 选择覆盖接地阻抗与接地类型
  let ground_R_ohm = feeder.ground?.R_ohm ?? 0.5;
  let ground_X_ohm = feeder.ground?.X_ohm ?? 0;
  let transformer = { ...feeder.transformer };
  if (groundingType) {
    const gi = resolveGroundingImpedance(groundingType, { voltage_kV: feeder.bus?.voltage_kV });
    ground_R_ohm = gi.R_ohm;
    ground_X_ohm = gi.X_ohm;
    transformer.secondary_neutral_ground = groundingType;
  }
  const sc = calculateShortCircuitIEC60909Multi({
    Un_kV: Un_kV || feeder.Un_kV || feeder.bus?.voltage_kV || 10,
    source: feeder.source,
    transformer,
    line: feeder.line,
    temp_operate_c,
    c_max,
    c_min,
    motors_percent,
    motors_X_R,
    ground_R_ohm,
    ground_X_ohm,
    z0_factor: feeder.line?.z0_factor ?? 3
  });
  return sc;
}